import script from "./AvatarUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarUploader.vue?vue&type=script&setup=true&lang=js"

import "./AvatarUploader.vue?vue&type=style&index=0&id=9fef5668&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fef5668"]])

export default __exports__